/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type me_RegisterPushTokenRequest = {
    app: me_RegisterPushTokenRequest.app;
    deviceId: string;
    expoToken: string;
    platform: me_RegisterPushTokenRequest.platform;
};
export namespace me_RegisterPushTokenRequest {
    export enum app {
        PARENT = 'parent',
        EMPLOYEE = 'employee',
        MANAGEMENT = 'management',
    }
    export enum platform {
        IOS = 'ios',
        ANDROID = 'android',
    }
}

